import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { PrepareComponent } from './features/scenario/components/prepare/prepare.component';
import { DecideComponent } from './features/scenario/components/decide/decide.component';
import { GameOverComponent } from './features/scenario/components/game-over/game-over.component';
import { SupportComponent } from './features/scenario/components/support/support.component';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  { path: 'scenario/prepare/:id', component: PrepareComponent },
  { path: 'scenario/decide/:id', component: DecideComponent },
  { path: 'scenario/decide/:id', component: DecideComponent },
  { path: 'game-over/:result/:id', component: GameOverComponent },
  { path: 'help-and-support/:id', component: SupportComponent },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
